<div *ngIf="patient">

    <div class="card">
        <div class="heading">

            <span class="pi pi-user"></span>&nbsp;
            <h3 id="h3"> Details of Selected Patient </h3>

        </div>

        <p-fieldset legend="Personal Details &nbsp; &nbsp;&nbsp;" [toggleable]="true" collapsed="true"
            (onAfterToggle)="open1()">
            <p-toolbar>

                <button pButton type="button" class="edit-button" icon="pi pi-pencil" label="Edit"
                    (click)="handleEdit()"></button>

                <p-tabView>

                    <p-tabPanel header="Basic Details">
                        <p-toast position="top-right"></p-toast>
                        <div>
                            <span>
                                <label for="float-fname" style="margin-right:2rem;">First Name</label>
                                <input id="float-fname" type="text" pInputText [(ngModel)]="patient1.first_name"
                                    (ngModelChange)="dosomething(patient1.first_name,'first_name')"
                                    [disabled]="this.disabled" required />
                            </span>
                            <span style="margin-left:10rem;">
                                <label for="float-mname" style="margin-right:2rem;">Middle Name</label>
                                <input id="float-mname" type="text" pInputText [(ngModel)]="patient1.middle_name"
                                    (ngModelChange)="dosomething(patient1.middle_name,'middle_name')"
                                    [disabled]="this.disabled" />
                            </span>
                            <div>
                                <p *ngIf="!patient1.first_name.length"
                                    style="display: inline;margin-left: 120px;color: red;">Enter First Name </p>
                            </div>
                        </div>

                        <div style="margin-top: 1rem;">
                            <span>
                                <label for="float-lname" style="margin-right:2rem;">Last Name</label>
                                <input id="float-lname" type="text" pInputText [(ngModel)]="patient1.last_name"
                                    (ngModelChange)="dosomething(patient1.last_name,'last_name')"
                                    [disabled]="this.disabled" required />
                            </span>
                            <span style="margin-left:10rem;">
                                <label for="float-relation" style="margin-right:4.2rem;">Relation</label>
                                <input id="float-relation" type="text" pInputText [(ngModel)]="patient1.relation"
                                    (ngModelChange)="dosomething(patient1.relation,'relation')" [disabled]="true" />
                            </span>
                            <div>
                                <p *ngIf="!patient1.last_name.length"
                                    style="display: inline;margin-left: 120px;color: red;">Enter Last Name </p>
                            </div>
                        </div>

                        <div style="margin-top:1rem">
                            <span>
                                <label for="float-email" style="margin-right:4.5rem;">Email</label>
                                <input id="float-email" type="text" pInputText
                                    [(ngModel)]="patient1.e_email"
                                    (ngModelChange)="dosomething(patient1.e_email,'e_email')"
                                    [disabled]="true" />
                            </span>
                            <span style="margin-left:10rem;">
                                <label for="float-dob" style="margin-right:2rem;">Date OF Birth</label>
                                <input id="float-dob" type="date" pInputText [(ngModel)]="patient1.date_of_birth"
                                    (ngModelChange)="dosomething(patient1.date_of_birth,'date_of_birth')"
                                    [disabled]="this.disabled" required />
                            </span>
                        </div>

                        <div style="margin-top:1rem">
                            <span>
                                <label style="margin-right:3.5rem;">Gender</label>
                                <p-radioButton name="Gender" value="male" label="Male" [(ngModel)]="patient1.gender"
                                    (ngModelChange)="dosomething(patient1.gender,'gender')" [disabled]="this.disabled">
                                </p-radioButton>
                                <p-radioButton name="Gender" value="female" label="Female" [(ngModel)]="patient1.gender"
                                    (ngModelChange)="dosomething(patient1.gender,'gender')" [disabled]="this.disabled">
                                </p-radioButton>
                                <p-radioButton name="Gender" value="other" label="Other" [(ngModel)]="patient1.gender"
                                    (ngModelChange)="dosomething(patient1.gender,'gender')" [disabled]="this.disabled">
                                </p-radioButton>
                            </span>
                        </div>
                        <div style="margin-top:3rem">
                            <span style="margin-left:50%;">
                                <button pButton type="button" style="width: 80px;" class="save-button" label="Save"
                                    icon="pi pi-save" class="p-button-sm" (click)="handleSave()"></button>
                            </span>
                        </div>


                    </p-tabPanel>


                    <p-tabPanel header="Address Details">
                        <p-toast position="top-right"></p-toast>
                        <div class="p-float-label">
                            <span>
                                <label style="margin-right:2.4rem;">Country Name</label>
                                <p-dropdown [style]="{'width':'16rem'}" [options]="countries"
                                    [(ngModel)]="selectedCountry" (ngModelChange)="onCountryChange($event)"
                                    optionLabel="country_name" [disabled]="this.disabled"
                                    [placeholder]="patient.country_name"></p-dropdown>
                            </span>
                            <span style="margin-left:3rem;">
                                <label style="margin-right:4rem;">State Name</label>
                                <p-dropdown [style]="{'width':'16rem'}" [options]="states" [(ngModel)]="selectedState"
                                    (ngModelChange)="onStateChange($event)" optionLabel="state_name"
                                    [disabled]="this.disabled" [placeholder]="patient.state_name" filter="true">
                                </p-dropdown>
                            </span>

                        </div>

                        <div class="p-float-label" style="margin-top: 1rem;">
                            <span>
                                <span>
                                    <label for="float-city" style="margin-right:7rem;">City</label>
                                    <input id="float-city" style="width: 16rem;" type="text" pInputText
                                        [(ngModel)]="patient1.city" (ngModelChange)="dosomething(patient1.city,'city')"
                                        [disabled]="this.disabled" />
                                </span>
                                <span style="margin-left:3rem;">
                                    <label for="float-zipcode" style="margin-right:5.3rem;">Zip Code</label>
                                    <input id="float-zipcode" style="width: 16rem;" type="text" pInputText
                                        [(ngModel)]="patient1.zip_code"
                                        (ngModelChange)="dosomething(patient1.zip_code,'zip_code')"
                                        [disabled]="this.disabled" />
                                </span>
                            </span>

                            <div>
                                <p *ngIf="!patient1.city.length" style="display: inline;margin-left: 9rem;color: red;">
                                    Enter City Details</p>
                                <p *ngIf="!patient1.zip_code.length"
                                    style="display: inline;margin-left: 40rem;color: red">Enter Zip Code Details </p>
                            </div>


                        </div>

                        <div style="margin-top: 1rem;">
                            <span>
                                <label for="float-address1" style="margin-right:4.1rem;">Address 1</label>
                                <input id="float-address1" type="text" style="width: 16rem;" pInputText
                                    [(ngModel)]="patient1.address_line_1"
                                    (ngModelChange)="dosomething(patient1.address_line_1,'address_line_1')"
                                    [disabled]="this.disabled" />
                            </span>
                            <span style="margin-left:3rem;">
                                <label for="float-address2" style="margin-right:5rem;">Address 2</label>
                                <input id="float-address2" type="text" style="width: 16rem;" pInputText
                                    [(ngModel)]="patient1.address_line_2"
                                    (ngModelChange)="dosomething(patient1.address_line_2,'address_line_2')"
                                    [disabled]="this.disabled" />
                            </span>
                            <div>
                                <p *ngIf="!patient1.address_line_1"
                                    style="display: inline;margin-left: 9rem;color: red;">Enter Primary Number</p>
                            </div>
                        </div>

                        <div style="margin-top: 1rem;">
                            <span>
                                <label for="float-primay" style="margin-right:1.2rem;">Primary Number</label>
                                <input id="float-primary" type="text" style="width: 4rem;" pInputText
                                    [(ngModel)]="patient1.phone_code" [disabled]="true" />
                                <input id="float-primary1" type="text" pattern="\d*" maxlength="20"
                                    style="width: 12rem;" pInputText [(ngModel)]="patient1.primary_contact_number"
                                    (ngModelChange)="dosomething(patient1.primary_contact_number,'primary_contact_number')"
                                    [disabled]="this.disabled" required />
                            </span>
                            <span style="margin-left:3rem;">
                                <label for="float-secondary" style="margin-right:1rem;">Secondary Number</label>
                                <input id="float-secondary" type="text" style="width: 4rem;" pInputText
                                    [(ngModel)]="patient1.phone_code" [disabled]="true" />
                                <input id="float-secondary1" type="text" pattern="\d*" maxlength="20"
                                    style="width: 12rem;" pInputText [(ngModel)]="patient1.secondary_contact_number"
                                    (ngModelChange)="dosomething(patient1.secondary_contact_number,'secondary_contact_number')"
                                    [disabled]="this.disabled" />
                            </span>
                            <div>
                                <p *ngIf="!patient1.primary_contact_number"
                                    style="display: inline;margin-left: 9rem;color: red;">Enter Primary Number</p>
                            </div>

                        </div>
                        <div style="margin-top:3rem">
                            <span style="margin-left:50%;">
                                <button pButton type="button" style="width: 80px;" class="save-button" label="Save"
                                    icon="pi pi-save" class="p-button-sm" (click)="handleSave()"></button>
                            </span>
                        </div>
                    </p-tabPanel>



                    <p-tabPanel header="Account Details">
                        <div class="p-float-label">
                            <span>
                                <label for="float-mrn" style="margin-right:2rem;">Medical Record Number</label>
                                <input id="float-mrn" type="text" pInputText [(ngModel)]="patient.medical_record_number"
                                    [disabled]="true" />
                            </span>
                            <span style="margin-left:5rem;">
                                <label for="float-astatus" style="margin-right:2rem;">Account Status</label>
                                <input id="float-astatus" type="text" pInputText [(ngModel)]="patient.account_status"
                                    [disabled]="true" />
                            </span>
                        </div>
                        <div style="margin-top: 1rem;">
                            <span>
                                <label for="float-validtill" style="margin-right:9rem;">Valid Till</label>
                                <input id="float-validtill" type="text" pInputText [(ngModel)]="patient1.valid"
                                    [disabled]="true" />
                            </span>
                        </div>

                    </p-tabPanel>

                </p-tabView>


            </p-toolbar>
        </p-fieldset>



        <p-fieldset legend=" Transaction Details " [toggleable]="true" [collapsed]="true" (onBeforeToggle)="should_display_transaction_table=true">

            <p-table #dt1 [columns]="cols1" [value]="TranactionDetails" [paginator]="true" [loading]="loading1" *ngIf="should_display_transaction_table"
                [showCurrentPageReport]="true" [paginator]="true"  [lazy]="true" (onLazyLoad) = "fetchTransactions($event)" 
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rows]="query.records_per_page"
                [rowsPerPageOptions]="page_list" [totalRecords]="total_records" pageLinks="3">
                <ng-template pTemplate="caption">
                    <div style="text-align: right">
                        
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns">
                            <b>{{col.header}}</b>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            <ng-container *ngIf="col.field === 'p_priority.consultation_name';else second">
                                {{ rowData['p_priority'].consultation_name }}</ng-container>
                            <ng-template #second>
                                <ng-container *ngIf="col.field === 'created_at';else third">
                                    {{ rowData[col.field] | date: 'MM/dd/yyyy'}}</ng-container>
                            </ng-template>
                            <ng-template #third>
                                <ng-container *ngIf="col.field === 'p_priority.priority_type';else fourth">
                                    {{ rowData['p_priority'].priority_type}}</ng-container>
                            </ng-template>
                            <ng-template #fourth>{{rowData[col.field]}}</ng-template>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft">
                    <p-button icon="pi pi-chevron-circle-left" (click)="prev()"></p-button>
                </ng-template>
            </p-table>
            <div>
                <p *ngIf="TranactionDetails.length==0" style="display: inline;margin-left: 500px;color: red">
                    {{transactionerror?.error.message}}</p>

            </div>
        </p-fieldset>








        <p-fieldset legend=" Consultation Details " [toggleable]="true" collapsed="false" (onBeforeToggle)="open3()">

            <p-table #dt [columns]="cols2" [value]="ConsltationDetails" [paginator]="true" [loading]="loading"
                [showCurrentPageReport]="true" [autoLayout]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rows]="5"
                [rowsPerPageOptions]="[5,10,15,20]" totalRecords="totalRecords" pageLinks="3">
                <ng-template pTemplate="caption">
                    <div class="table-header float-right">
                        <div class="ui-table-globalfilter-container">
                            <input type="text" pInputText size="50" placeholder="Search" (input)="
                                dt.filterGlobal(
                                    $event.target.value,
                                    'contains'
                                )
                            " style="width: 15vw; margin-left: 75%;" />
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns">
                            <b>{{col.header}}</b>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            <ng-container *ngIf="col.field === 'communication_type.communication_name';else second">
                                {{ rowData['communication_type'].communication_name  }}</ng-container>
                            <ng-template #second>
                                <ng-container *ngIf="col.field === 'p_transactions.paypal_transaction_id';else third">
                                    {{ rowData['p_transactions']?.paypal_transaction_id || "N/A" }}</ng-container>
                            </ng-template>
                            <ng-template #third>
                                <ng-container *ngIf="col.field === 'p_transactions.razor_pay_id';else fourth">
                                    {{ rowData['p_transactions']?.razor_pay_id || "N/A"}}</ng-container>
                            </ng-template>
                            <ng-template #fourth>
                                <ng-container *ngIf="col.field === 'p_transactions.transaction_no';else five">
                                    {{ rowData['p_transactions']?.transaction_no}}</ng-container>
                            </ng-template>
                            <ng-template #five>
                                <ng-container *ngIf="col.field === 'consultation_type.consultation_name';else six">
                                    {{ rowData['consultation_type'].consultation_name}}</ng-container>
                            </ng-template>
                            <ng-template #six>
                                <ng-container *ngIf="col.field === 'p_consultation_appointment';else seven">
                                    <!--{{ rowData['speciality'].specialty_name}}-->
                                    <span *ngFor="let item of rowData[col.field]">

                                        {{item['d_specialty_type'].specialty_name+" ,"}}

                                    </span>
                                </ng-container>
                            </ng-template>
                            <ng-template #seven>
                                <ng-container *ngIf="col.field === 'id';else eight">
                        <td class="tdentry" style="width: 100px;">
                            <button pButton style="width: 60px; margin-left: 5%;" label="View"
                                [disabled]="this.history_posting"
                                (click)="getConsultationsHistoryData(rowData[col.field])"></button>
                        </td>

                        </ng-container>
                </ng-template>
                <ng-template #eight>
                    <ng-container *ngIf="col.field === 'p_consultation_appointment.doc';else nine">
                        <span *ngFor="let item of rowData['p_consultation_appointment']">
                            <span *ngIf="item['egd_users'] !=null;else tba">
                                {{item['egd_users']?.first_name+" "+item['egd_users']?.last_name+" ,"}}
                            </span>
                            <ng-template #tba>TBA</ng-template>

                        </span>
                    </ng-container>
                </ng-template>
                <ng-template #nine>{{rowData[col.field]}}</ng-template>
                </td>
                </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft">
                    <p-button icon="pi pi-chevron-circle-left" (click)="prev()"></p-button>
                </ng-template>
            </p-table>


            <div>
                <p *ngIf="ConsltationDetails.length==0" style="display: inline;margin-left: 500px;color: red">
                    {{consultaionerror?.error.message}}</p>

            </div>

        </p-fieldset>




        <p-dialog header="Appointment History" *ngIf="historyDialog" [(visible)]="historyDialog" [baseZIndex]="10000"
            [closable]="true" [modal]="true" [style]="{'width':'100%'}" [contentStyle]="{'text-align':'center'}">

            <app-patient-appointment-history
                *ngIf="history_response.success!=null && history_response.success==true && history" [history]="history">
            </app-patient-appointment-history>

            <div class="row container justify-content-center text-center alert alert-danger"
                *ngIf="history_response.success!=null && history_response.success==false">
                <p *ngIf="history_response.error!=null">{{history_response.error.message}}</p>
                <div *ngIf="history_serverError?.error!=null && history_serverError?.statusCode!=500">
                    <p *ngFor="let message of history_serverError?.message">{{message}}</p>
                </div>
                <div *ngIf="history_serverError?.error!=null && history_serverError?.statusCode==500">
                    <p>{{history_serverError?.message}}</p>
                </div>

            </div>

            <ng-template pTemplate="footer">
                <p-button icon="pi pi-check" (click)="historyDialog=false;" label="Close" styleClass="p-button-text">
                </p-button>
            </ng-template>
        </p-dialog>




    </div>
</div>